module.exports = __webpack_public_path__ + "img/ewm.663bd39c.png";